module.exports = __webpack_public_path__ + "../resources/img/ic_sleet_weather.e56e677f.svg";